import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './CodeClashWaitingPage.css';

function CodeClashWaitingPage() {
  const [timeLeft, setTimeLeft] = useState({});
  const [isButtonActive, setIsButtonActive] = useState(false);
  const navigate = useNavigate();

  // Helper to format time into HH:MM:SS
  const formatTime = (ms) => {
    const totalSeconds = Math.floor(ms / 1000);
    const hours = String(Math.floor(totalSeconds / 3600)).padStart(2, '0');
    const minutes = String(Math.floor((totalSeconds % 3600) / 60)).padStart(2, '0');
    const seconds = String(totalSeconds % 60).padStart(2, '0');
    return `${hours}:${minutes}:${seconds}`;
  };

  useEffect(() => {
    const updateCountdown = () => {
      const nowUTC = new Date();
      const nowIST = new Date(nowUTC.getTime() + (5.5 * 60 * 60 * 1000)); // Convert to IST

      // Fixed target: 9th April 2025 at 2:55 PM IST
      const targetIST = new Date('2025-04-09T14:55:00+05:30');

      const diff = targetIST - nowIST;

      if (diff <= 0) {
        setTimeLeft({ time: '00:00:00' });
        setIsButtonActive(true);
      } else {
        setTimeLeft({ time: formatTime(diff) });
      }
    };

    updateCountdown();
    const interval = setInterval(updateCountdown, 1000);
    return () => clearInterval(interval);
  }, []);

  const handleStart = () => {
    if (isButtonActive) {
      navigate('/codeClashquestion');
    }
  };

  return (
    <div className="codeclash-container">
      <div className="codeclash-content">
        <h1 className="codeclash-heading">⏳ CodeClash is about to begin!</h1>
        {!isButtonActive && (
          <p className="codeclash-subtext">
            Time Remaining: <span className="codeclash-timer">{timeLeft.time}</span>
          </p>
        )}
        <button
          className="codeclash-start-button"
          disabled={!isButtonActive}
          onClick={handleStart}
        >
          {isButtonActive ? 'Start Competition 🚀' : 'Waiting...'}
        </button>
      </div>
    </div>
  );
}

export default CodeClashWaitingPage;
